/**
 * wotcFromAction
 *
 * @package                onboard
 * @subpackage             wotcFromAction
 * @category               Actions
 * @DateOfCreation         28 june 2019
 * @ShortDescription       This is responsible for all business actions
 */ 

import { wotcFormConstants,configConstants } from '../_constants';
import { wotcFormService } from '../_services';

export const wotcFormAction = {
    autofilldetails,
    saveWotcForm,
    updateWotcForm,
    resetState
   
};



/**
 * @DateOfCreation        8 july 2019
 * @ShortDescription      This function is responsible for user list
 * @return                JSON Object
 */
function autofilldetails(model) {
    return dispatch => {
        wotcFormService.formDetails(model)
            .then(
                response => { 
                    let responseData = response.data;
                    if(response.code == configConstants.CORS_ERROR_CODE) {
                        dispatch(failure(response.message));                    
                    }else if(response.status == configConstants.SUCCESS_CODE) {

                        dispatch(success(responseData.data));
                    }else if(response.status == configConstants.BAD_REQUEST_CODE) {
                        dispatch(failure(responseData.message));
                    }else if(response.status == configConstants.EXCEPTION_CODE) {
                        dispatch(failure(responseData.title));
                    }else if(response.status == configConstants.UNAUTHENTICATE_CODE) {
                        dispatch(unauthorize(responseData.message));
                    }else{
                        dispatch(failure(response));
                    }
                }
            ).catch(function (response) {
                dispatch(failure(response));
            });
    };

    function request(autofilldetail) { return { type : wotcFormConstants.AUTOFILL_REQUEST, autofilldetail } }
    function success(autofilldetail) { return { type : wotcFormConstants.AUTOFILL_SUCCESS, autofilldetail } }
    function failure(error) { return { type : wotcFormConstants.AUTOFILL_FAILURE, errorMsg:error } }
    function unauthorize(error) { return { type : configConstants.UNAUTHENTICATE, error } }
}




/**
 * @DateOfCreation        8 july 2019
 * @ShortDescription      This function is responsible for user list
 * @return                JSON Object
 */
function saveWotcForm(model) {
    return dispatch => {
        dispatch(request({ model }));
        wotcFormService.saveWotcForm(model)
            .then(
                response => { 
                    let responseData = response.data;
                    if(response.code == configConstants.CORS_ERROR_CODE) {
                        dispatch(failure(response.message));                    
                    }else if(response.status == configConstants.SUCCESS_CODE) {

                        let successMsg = { 'message' : responseData.message, 'detail' : responseData.result };
                        dispatch(success(successMsg));
                    }else if(response.status == configConstants.BAD_REQUEST_CODE) {
                        dispatch(failure(responseData.message));
                    }else if(response.status == configConstants.EXCEPTION_CODE) {
                        dispatch(failure(responseData.title));
                    }else if(response.status == configConstants.UNAUTHENTICATE_CODE) {
                        dispatch(unauthorize(responseData.message));
                    }else{
                        dispatch(failure(response));
                    }
                }
            ).catch(function (response) {
                dispatch(failure(response));
            });
    };

    function request(model) { return { type : wotcFormConstants.WOTC_ADD_REQUEST, model } }
    function  success(successMsg) { return { type : wotcFormConstants.WOTC_ADD_SUCCESS, successMsg } }
    function failure(error) { return { type : wotcFormConstants.WOTC_ADD_FAILURE, errorMsg:error } }
    function unauthorize(error) { return { type : configConstants.UNAUTHENTICATE, error } }
}

/**
 * @DateOfCreation        8 july 2019
 * @ShortDescription      This function is responsible for update Wotc form
 * @return                JSON Object
 */
function updateWotcForm(model) {
    return dispatch => {
        dispatch(request({ model }));
        wotcFormService.updateWotcForm(model)
            .then(
                response => { 
                    let responseData = response.data;
                    if(response.code == configConstants.CORS_ERROR_CODE) {
                        dispatch(failure(response.message));                    
                    }else if(response.status == configConstants.SUCCESS_CODE) {

                        let successMsg = { 'message' : responseData.message, 'detail' : responseData.result };
                        dispatch(success(successMsg));
                    }else if(response.status == configConstants.BAD_REQUEST_CODE) {
                        dispatch(failure(responseData.message));
                    }else if(response.status == configConstants.EXCEPTION_CODE) {
                        dispatch(failure(responseData.title));
                    }else if(response.status == configConstants.UNAUTHENTICATE_CODE) {
                        dispatch(unauthorize(responseData.message));
                    }else{
                        dispatch(failure(response));
                    }
                }
            ).catch(function (response) {
                dispatch(failure(response));
            });
    };

    function request(model) { return { type : wotcFormConstants.WOTC_UPDATE_REQUEST, model } }
    function  success(successMsg) { return { type : wotcFormConstants.WOTC_UPDATE_SUCCESS, successMsg } }
    function failure(error) { return { type : wotcFormConstants.WOTC_UPDATE_FAILURE, errorMsg:error } }
    function unauthorize(error) { return { type : configConstants.UNAUTHENTICATE, error } }
}

function resetState()
{
    return dispatch => { dispatch(request()); }
    function request() { return { type : wotcFormConstants.WOTC_RESET_STATE } }
}